var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetsuite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21587_168466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9576 19.9718H19.4295V28.2193H21.1581V31.4421H15.9576V19.9718ZM32.0277 27.5601H28.5558V19.3126H26.8272V16.0898H32.0277V27.5601Z",
    fill: "#BACCDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.152 15.2988H26.1241V24.7182L21.9052 19.2834H15.152V15.2988ZM32.8188 32.2478H21.8466V22.8284L26.0655 28.2633H32.8188",
    fill: "#125580"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21587_168466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21.9736,
    fill: "white",
    transform: "translate(13 13.0137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetsuite);
export default __webpack_public_path__ + "static/media/netsuite.a0b1732bab30f6bc1be8c3ca2749405e.svg";
export { ForwardRef as ReactComponent };